import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";

const TRANSPORT_UNIT_TYPE = "numberOfCases";

export interface TransportUnitValue {
  packageUnitValue: number;
  palletWidth: number;
  palletLength: number;
}

export type PackagingUnitSaveValue = number | TransportUnitValue;

export interface PackagingDataSnapshot {
  unitSize?: number;
  numberOfBaseUnits?: number;
  numberOfPacks?: number;
  numberOfCases?: number;
  palletWidth?: number;
  palletLength?: number;
  unitSizeWeightUnit?: MEASUREMENT_TYPES;
  packagingName?: string;
  [key: string]: unknown;
}

interface BuildPackagingDetailsPayloadInput {
  gateId: string;
  gateIdKey: "farmGateId" | "processGateId";
  packagingId: string;
  packagingType: string;
  unitSizeWeightUnit: MEASUREMENT_TYPES;
  value: PackagingUnitSaveValue;
  snapshot?: PackagingDataSnapshot | null;
}

const DEFAULT_SNAPSHOT = {
  unitSize: 0,
  numberOfBaseUnits: 0,
  numberOfPacks: 0,
  numberOfCases: 0,
  palletWidth: 0,
  palletLength: 0
};

const isTransportUnitValue = (value: unknown): value is TransportUnitValue =>
  typeof value === "object" &&
  value !== null &&
  "packageUnitValue" in value &&
  "palletWidth" in value &&
  "palletLength" in value;

export const buildPackagingDetailsPayload = ({
  gateId,
  gateIdKey,
  packagingId,
  packagingType,
  unitSizeWeightUnit,
  value,
  snapshot
}: BuildPackagingDetailsPayloadInput) => {
  const currentSnapshot = { ...DEFAULT_SNAPSHOT, ...snapshot };

  const packageDetails = {
    [gateIdKey]: gateId,
    packagingId,
    packagingType,
    unitSize: currentSnapshot.unitSize,
    unitSizeWeightUnit,
    numberOfBaseUnits: currentSnapshot.numberOfBaseUnits,
    numberOfPacks: currentSnapshot.numberOfPacks,
    numberOfCases: currentSnapshot.numberOfCases,
    palletWidth: currentSnapshot.palletWidth,
    palletLength: currentSnapshot.palletLength
  };

  const isTransportSave = packagingType === TRANSPORT_UNIT_TYPE;

  const data = {
    ...packageDetails,
    [packagingType]: isTransportSave && isTransportUnitValue(value) ? value.packageUnitValue : value,
    palletWidth:
      isTransportSave && isTransportUnitValue(value) ? value.palletWidth : currentSnapshot.palletWidth,
    palletLength:
      isTransportSave && isTransportUnitValue(value) ? value.palletLength : currentSnapshot.palletLength
  };

  return {
    data,
    packagingType,
    [gateIdKey]: gateId,
    packagingId
  };
};
